import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './index.css';
import App from './App';

const clerkPublishableKey = process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY || process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || process.env.VITE_STRIPE_PUBLISHABLE_KEY;

const isClerkEnabled = Boolean(clerkPublishableKey);
const stripePublishableKeyExists = Boolean(stripePublishableKey);
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isClerkEnabled ? (
      <ClerkProvider publishableKey={clerkPublishableKey}>
        {stripePublishableKeyExists ? (
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        ) : (
          <App />
        )}
      </ClerkProvider>
    ) : (
      <App clerkUnavailable />
    )}
  </React.StrictMode>
);
